$(function(){
	

	/* --------- Update facebook link  --------- */

	var url=window.location;
	$(".fb-share-button").attr('data-href',url);
 

	/* --------- Menu secondaire li lien  --------- */
	
	$("#menu-deroulant-section li, #navRapide ul li").click(function (){
		var lien=$(this).children("a").attr("href");
		window.location.href=lien;
	}); 
	 
	/* --------- Menu principal li navigable ---------*/
	$('#navPrincipal nav ul li').click(function() {
		var id=$(this).attr('id');
	        switch(id) {
			    case 'sante-envi':
			         $(this).find(".sous-menu").toggleClass( "mobileopen" )
			        break;
			    case 'ethique-comm':
			         $(this).find(".sous-menu").toggleClass( "mobileopen" )
			        break;
			}
    }); 

	
	
	/* --------- Menu principal mobile --------- */
	
	$("#menu-icon").click(function () {
		$("#navPrincipal").toggle();
	});
	
	/* ---------- Search --------------  */
	$( "#search-form" ).submit(function () {
	  var txt_recherche=$('#txt_recherche').val();
      var adresseResultat="http://www.ogm.gouv.qc.ca/resultat_recherche.html?Recherche="+txt_recherche;
      window.location.href=adresseResultat;
      return false;
    });
		
	/* --------- Image au hazard à l'accueil et resize --------- */
	var images;
	var imageBack_Web=['accueil1.jpg', 'accueil2.jpg', 'accueil3.jpg', 'accueil4.jpg'];
	var imageBack_Mobile=imageBack_Web;
	var chiffre=Math.floor(Math.random() * imageBack_Web.length);
	


	chargement_image_background();
	
	$(window).resize(function() {
		chargement_image_background();		
	});
	
	function chargement_image_background(){
		/*regarde le title de la page d'accueil pour voir si on est dans un dossier */
		var longChemin;
		var chemin='';
		var title= $('title').text()
		if(title.match(/[>]/)!=null){chemin='../';}
		if(title.match(/[-]/)!=null){chemin='../../';}
		if(title.match(/[+]/)!=null){chemin='../../../';}
		if(title=="OGM : Source d'information sur les organismes génétiquement modifés - Accueil" || title=="OGM : À propos" || title=="OGM : Foire au questions" || title=="OGM : Glossaire" || title=="OGM : Liens utiles") {
			chemin='';
		}
		
		if($(window).width()>1120){
			$('#navPrincipal').css('display','block');
		}else{
			$('#navPrincipal').css('display','none');
		}
		
		
		if($(window).width()<480 && $(window).width()>400){
			var images = imageBack_Mobile;
			var dossier =chemin+"_images_mobile";
			$('header h1 img').attr('src',chemin+'_images_mobile/h1-mobile.gif');
			
		}
		if($(window).width()<410){
			$('header h1 img').attr('src',chemin+'_images_mobile/h1-mobile-mini.gif');
			var images = imageBack_Mobile;
			var dossier =chemin+"_images_mobile";
		}
		if($(window).width()>481){   
		var images = imageBack_Web;
		var dossier =chemin+"_images";
		$('header h1 img').attr('src',chemin+'_images/h1.png');
		}
		$('#image-nav').css({'background-image': 'url('+dossier+'/' + images[chiffre] + ')'});
		return false;
		
	}
	
	
	
	
	/* --------- Détection des liens externes --------- */
	$("#texte-principal a[href^='http'], .sectionSansMenu a[href^='http'], #repertoire-reference a[href^='http']")
    .not(":has(img)")
    .not("a[href^='http:\/\/http://www.ogm.gouv.qc.ca']")//inscrire le site ou nous sommes
    .not("a[href^='http:\/\/http://www.ogm.gouv.qc.ca']")//inscrire le site ou nous sommes encore 
	.not("a[href$='.pdf']")
        .addClass("lienExterne")
        .attr({target: "_blank"});
		
	/* --------- Système du glossaire --------- */
	var largeur=430;
	var hauteur=400;
	$('.glossaire').click(function() {	
	
		var longChemin;
		var chemin='../_glossaire/';
		var title= $('title').text()
		if(title.match(/[>]/)!=null){chemin='../../_glossaire/';}
		if(title.match(/[-]/)!=null){chemin='../../../_glossaire/';}
		if(title.match(/[+]/)!=null){chemin='../../../../_glossaire/';}
		if(title=="OGM : Source d'information sur les organismes génétiquement modifés - Accueil" || title=="OGM : À propos" || title=="OGM : Foire au questions" || title=="OGM : Glossaire" || title=="OGM : Liens utiles") {
			chemin='_glossaire/';
		}
		
		var mot=$(this).attr("rel");
		var contenu=chemin+mot+'.html';
		$('#framePopUp').show();
		$('#inPopUp').css({'marginTop':'-'+hauteur/2+'px','marginLeft':'-'+largeur/2+'px'});
		$('#inPopUp').load(contenu);
		$('#framePopUp').fadeIn('fast');
		$('#inPopUp').show();
	});
	
	$('#inPopUp').click(function() {	
		$('#framePopUp').hide();
		$('#inPopUp').hide();
	});
	$("#framePopUp").click(function() {	
		$('#framePopUp').hide();
		$('#inPopUp').hide();
	});
	
});
